<template>
  <div class="modal fade text-center" id="pay-redirect" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <modal-header v-if="currentPaymentMethod.id == 'airwallex'"></modal-header>
        <template v-else>
          <modal-header v-if="!!errorMessage"></modal-header>
        </template>
        
        <div class="modal-body">
          <template v-if="errorMessage === ''">
            <spinner :show="loading" class="spinner-component"></spinner>
            <p v-if="currentPaymentMethod.id == 'airwallex'">{{ $t('redirect') }}{{ $t('airwallex') }}{{ $t('wait') }}</p>
            <p v-else>{{ $t('redirect') }}{{ $t(currentPaymentMethod.id) }}{{ $t('wait') }}</p>
          </template>
          <p v-if="errorMessage !== ''">{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import Spinner from '../../Spinner.vue'
  import ModalHeader from '../../modalHeader/ModalHeader.vue'
  import locales from './lang'
  import cookie from '../../../lib/cookie'

  export default {
    name: 'pay-redirect',
    components: {Spinner, ModalHeader},
    data: function () {
      return {
        loading: false,
        errorMessage: ''
      }
    },
    locales,
    computed: {
      isSubscribe() {
        if (window.localStorage.getItem('isSubscribe')) {
          window.localStorage.removeItem('isSubscribe')
          return true
        }
      },
      currentPackage() {
        if (window.localStorage.getItem('currentPackage')) {
          return JSON.parse(window.localStorage.getItem('currentPackage'))
        }
      },
      currentPaymentMethod() {
        if (window.localStorage.getItem('currentPaymentMethod')) {
          return JSON.parse(window.localStorage.getItem('currentPaymentMethod'))
        }
        return {}
      }
    },
    mounted() {
      window.localStorage.removeItem('closeWindow')
      if (this.currentPaymentMethod.id) {
        this.loading = true
        $('#pay-redirect').modal({
          show: true,
          backdrop: 'static',
          keyboard: false
        })
        window.localStorage.removeItem('currentPaymentMethod')
        if (this.isSubscribe) {
          this.subscribe()
        } else this.redirect()
      }

      window.addEventListener( 'beforeunload',e =>{
        window.localStorage.setItem('closeWindow', 'true')
      })
    },
    destroyed () {
      window.removeEventListener( 'beforeunload',e =>{
        window.localStorage.removeItem('closeWindow')
      });
    },
    methods: {
      redirect() {
        this.loading = true
        let wap = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 1 : 0
        this.$http.post(`api/topup?web=1&wap=${wap}&version=v2`, {
          payment_method_id: this.currentPaymentMethod.id,
          package_id: this.currentPackage.id,
          sub_channel: this.currentPaymentMethod.channel_id || '',
          promotion_source: cookie.getCookie('promotion_source') || ''
        }).then((response) => {
          if (response.body.code === 0) {
            if (this.currentPaymentMethod.channel_id) {
              $('head').append('<meta name="referrer" content="no-referrer"/>')
            }
            window.localStorage.setItem('orderNumber', response.body.data.order_id)
            window.localStorage.setItem('orderTracked', false)
            window.location.replace(response.body.data.payment_extras.redirect_url)
            if (this.currentPaymentMethod.channel_id) {
              $('meta[name=referrer]').remove()
            }
          } else {
            this.errorMessage = response.body.message
            window.localStorage.setItem('errorMessage', response.body.message)
            this.loading = false
          }
        })
      },
      subscribe() {
        this.loading = true
        this.$http.post('api/topup-subscription/create?web=1', {
          payment_method_id: this.currentPaymentMethod.id,
          package_id: this.currentPackage.id,
          sub_channel: this.currentPaymentMethod.channel_id || '',
          promotion_source: cookie.getCookie('promotion_source') || ''
        }).then((response) => {
          if (response.body.code === 0) {
            if (this.currentPaymentMethod.channel_id) {
              $('head').append('<meta name="referrer" content="no-referrer"/>')
            }
            window.localStorage.setItem('subscriptionId', response.body.data.subscription_id)
            window.location.replace(response.body.data.subscription_extras.redirect_url)
            if (this.currentPaymentMethod.channel_id) {
              $('meta[name=referrer]').remove()
            }
          } else {
            if (response.body.code === 141) {
              let subscriptionInfo = {
                subscription_id: response.body.data.subscription_id,
                payment_method: response.body.data.payment_method_name,
                package_name: response.body.data.package_detail.name
              }
              this.$parent.setSubscriptionInfo(subscriptionInfo)
            } else {
              this.errorMessage = response.body.message
              window.localStorage.setItem('errorMessage', response.body.message)
            }
            this.loading = false
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";
  @import "../../../assets/scss/reset-modal";

  .modal-dialog {
    @include modal-dialog($height: 3.1rem);
    @media (max-width: 767px) {
      margin: calc(50vh - 1.55rem) 0 0 -45% !important;
    }
  }

  .modal-content {
    height: 3.1rem;
  }

  .modal-body {
    padding: .5rem 0 .8rem 0;
    .spinner-component {
      margin: 0 auto;
    }
    p {
      margin-top: .6rem;
      line-height: .3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// PayRedirect.vue?4961634d